import React from 'react';
import WidgetReference from './WidgetReference';

export default function Affiliates() {
  return (
    <>
      <WidgetReference guideId="affiliates" />
    <iframe
      src="https://scribehow.com/o/_ygSvBcHTUyj_X5hGoV2bw/viewer/How_to_set_up_Affiliates__USLY4PRwRN2HzhJo0kWurw"
      height="640"
      title="Affiliates"
      allowFullScreen
    />
    </>
  );
}
